module.exports = __webpack_public_path__ + "assets/img/34c36f6ccae41a0b526255dfdfe9081d.jpg";